(() => {
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const KEYS = ['good', 'better', 'best'];

  const methods = {
    mobileSlots() {
      const eq = this.kit.slots.filter(s => s.group === 'equipment');
      return {eq, ess: this.kit.slots.filter(s => s.group !== 'equipment'), steps: eq.length + 1};
    },

    options(slot) {
      const seen = new Set();
      return KEYS.filter(k => slot.picks[k] && !seen.has(slot.picks[k].label) && seen.add(slot.picks[k].label));
    },

    totals() {
      let was = 0, now = 0, count = 0;
      for (const slot of this.kit.slots) {
        if (this.removed.has(slot.slot)) continue;
        const r = this.resolve(slot, this.tier);
        if (r.unavailable) continue;
        const p = this.price(r.pick);
        was += p.was; now += p.now; count += 1;
      }
      return {was, now, count};
    },

    priceStack(pick) {
      const p = this.price(pick);
      return `<span class="abk-m-price"><strong>${this.fmt(p.now)}</strong>${p.was > p.now ? `<s>${this.fmt(p.was)}</s>` : '<small>no discount</small>'}</span>`;
    },

    tankPrice() { return Number(this.mainVariant()?.price || 0); },

    renderMobile() {
      if (!this.mBound) {
        this.mBound = true;
        this.addEventListener('click', event => this.mobileClick(event));
      }
      ['[data-tiers]', '[data-signals]', '[data-grid]', '[data-summary]'].forEach(s => { const el = this.querySelector(s); if (el) el.innerHTML = ''; });
      const host = this.querySelector('[data-mobile]');
      if (!host) return;
      const {eq} = this.mobileSlots();
      const tiers = this.data.tiers.map(t => {
        const on = t.id === this.tier;
        return `<button type="button" role="radio" aria-checked="${on}" class="abk-m-seg__btn${on ? ' is-on' : ''}" data-tier="${t.id}"><strong>${esc(t.label)}</strong><span>${this.fmt(this.tierTotals(t.id).now)}</span></button>`;
      }).join('');
      const current = this.data.tiers.find(t => t.id === this.tier);
      const swaps = this.tierTotals(this.tier).swaps;
      const rows = this.kit.slots.map(slot => {
        const r = this.resolve(slot, this.tier);
        const off = this.removed.has(slot.slot);
        const step = slot.group === 'equipment' ? eq.indexOf(slot) : eq.length;
        return `<button type="button" class="abk-m-row${off ? ' is-removed' : ''}" data-step="${step}">
          <span class="abk-m-thumb">${this.image(r.pick, 44)}</span>
          <span class="abk-m-row__info"><small>${esc(slot.slot)}</small><span>${off ? 'Removed' : esc(r.pick.label)}</span></span>
          ${off ? '' : this.priceStack(r.pick)}<span class="abk-m-chev" aria-hidden="true">›</span></button>`;
      }).join('');
      const tot = this.totals();
      host.innerHTML = `
        <div class="abk-m-seg" role="radiogroup" aria-label="Kit level">${tiers}</div>
        <p class="abk-m-status">${esc(current?.copy || '')} · <b class="${swaps ? 'is-warn' : ''}">${swaps ? `${swaps} out-of-stock pick${swaps > 1 ? 's' : ''} swapped` : 'all in stock'}</b></p>
        <div class="abk-m-list">${rows}<div class="abk-m-list__total"><span>Kit · ${tot.count} items</span><span>${tot.was > tot.now ? `<s>${this.fmt(tot.was)}</s>` : ''}<strong>${this.fmt(tot.now)}</strong></span></div></div>
        <button type="button" class="abk-m-custom" data-step="0">Customise step by step</button>
        ${tot.was > tot.now ? `<p class="abk-m-note">You save <b>${this.fmt(tot.was - tot.now)}</b>. 10% Builder discount on eligible items, applied in your basket.</p>` : ''}
        <div class="abk-m-bar"><span><small>Tank + ${esc(current?.label || '')} kit</small><strong>${this.fmt(this.tankPrice() + tot.now)}</strong>${tot.was > tot.now ? `<em>Saving ${this.fmt(tot.was - tot.now)}</em>` : ''}</span>
          <button type="button" class="abk-m-btn" data-add>Add tank + kit</button></div>
        <p class="abk-status" data-status role="status" aria-live="polite"></p>`;
      this.renderStepper();
    },

    optionCard(slot, key, selected) {
      const pick = slot.picks[key];
      const ok = this.available(pick);
      const on = key === selected;
      const fits = (on ? pick.fits : pick.fits.slice(0, 1)).map(f => `<li>${esc(f)}</li>`).join('');
      const ev = on && pick.evidence ? `<li class="is-ev">${esc(pick.evidence)}</li>` : '';
      return `<button type="button" role="radio" aria-checked="${on}" class="abk-m-opt${on ? ' is-on' : ''}" data-pick="${key}" data-slot="${esc(slot.slot)}" ${ok ? '' : 'disabled'}>
        <span class="abk-m-opt__top"><span class="abk-pill abk-pill--${key}">${esc(this.tierNames(slot, key))}</span><span class="abk-m-radio"></span></span>
        <span class="abk-m-opt__main"><span class="abk-m-thumb abk-m-thumb--lg">${this.image(pick, 64)}</span>
          <span><strong>${esc(pick.label)}</strong>${this.priceStack(pick)}<em class="${ok ? '' : 'is-out'}">${ok ? 'In stock' : 'Out of stock'}</em></span></span>
        <ul>${fits}${ev}</ul></button>`;
    },

    renderStepper() {
      let host = this.querySelector('[data-stepper]');
      if (!host) return;
      document.documentElement.classList.toggle('abk-lock', this.step != null);
      if (this.step == null) { host.innerHTML = ''; return; }
      const {eq, ess, steps} = this.mobileSlots();
      const i = this.step;
      const bar = Array.from({length: steps}, (_, k) => `<span class="${k <= i ? 'is-on' : ''}"></span>`).join('');
      const tot = this.totals();
      let body = '', next = '';
      if (i < eq.length) {
        const slot = eq[i];
        const r = this.resolve(slot, this.tier);
        const off = this.removed.has(slot.slot);
        body = `<p class="abk-st__eyebrow">Step ${i + 1} · ${esc(slot.slot)}</p><h3>Choose your ${esc(slot.slot.toLowerCase())}</h3>
          <p class="abk-st__intro">Every option fits your ${esc(this.dataset.title)}. Your ${esc(this.label(this.tier))} kit includes the ${esc(this.label(this.tier))} pick.</p>
          ${off ? `<p class="abk-st__removed">Removed from your kit.</p>` : this.options(slot).map(k => this.optionCard(slot, k, r.key)).join('')}
          <button type="button" class="abk-st__skip" data-toggle="${esc(slot.slot)}">${off ? 'Add it back' : `I don’t need ${esc(slot.slot.toLowerCase())}`}</button>`;
        next = i + 1 < eq.length ? eq[i + 1].slot : 'Essentials';
      } else if (i === eq.length) {
        body = `<p class="abk-st__eyebrow">Step ${i + 1} · Essentials</p><h3>Essentials for the first fill</h3><p class="abk-st__intro">Sized for this tank. Remove anything you already have.</p>` +
          ess.map(slot => {
            const r = this.resolve(slot, this.tier);
            const off = this.removed.has(slot.slot);
            const opts = this.options(slot);
            const chips = opts.length > 1 && !off ? `<span class="abk-st__chips">${opts.map(k => `<button type="button" class="${k === r.key ? 'is-on' : ''}" data-pick="${k}" data-slot="${esc(slot.slot)}" ${this.available(slot.picks[k]) ? '' : 'disabled'}>${esc(this.tierNames(slot, k))}</button>`).join('')}</span>` : '';
            return `<div class="abk-st__ess${off ? ' is-removed' : ''}"><span class="abk-m-thumb">${this.image(r.pick, 44)}</span>
              <span class="abk-st__ess-info"><small>${esc(slot.slot)}</small><strong>${esc(r.pick.label)}</strong><span>${esc(r.pick.fits[0] || '')}</span>${chips}</span>
              <span class="abk-st__ess-side">${off ? '' : this.priceStack(r.pick)}<button type="button" data-toggle="${esc(slot.slot)}">${off ? 'Add' : 'Remove'}</button></span></div>`;
          }).join('');
        next = 'Review';
      } else {
        const rows = this.kit.slots.map(slot => {
          const r = this.resolve(slot, this.tier);
          const off = this.removed.has(slot.slot);
          const step = slot.group === 'equipment' ? eq.indexOf(slot) : eq.length;
          const tag = off ? '<em class="is-off">Removed</em>' : (r.key !== this.tier ? `<em>Now ${esc(this.label(r.key))}</em>` : '');
          return `<div class="abk-m-row abk-m-row--static${off ? ' is-removed' : ''}"><span class="abk-m-thumb">${this.image(r.pick, 40)}</span>
            <span class="abk-m-row__info"><small>${esc(slot.slot)} ${tag}</small><span>${esc(r.pick.label)}</span></span>
            ${off ? '' : `<span class="abk-m-price"><strong>${this.fmt(this.price(r.pick).now)}</strong></span>`}<button type="button" class="abk-st__edit" data-step="${step}">Edit</button></div>`;
        }).join('');
        body = `<h3>${esc(this.heading())} is ready</h3><p class="abk-st__intro">${esc(this.dataset.title)} · ${esc(this.label(this.tier))} kit</p><div class="abk-m-list">${rows}</div>
          <div class="abk-st__sum"><span><span>Tank</span><span>${this.fmt(this.tankPrice())}</span></span><span><span>Kit · ${tot.count} items</span><span>${tot.was > tot.now ? `<s>${this.fmt(tot.was)}</s>` : ''}${this.fmt(tot.now)}</span></span>
          ${tot.was > tot.now ? `<span class="is-save"><span>You save</span><span>${this.fmt(tot.was - tot.now)}</span></span>` : ''}<span class="is-total"><span>Total</span><strong>${this.fmt(this.tankPrice() + tot.now)}</strong></span></div>`;
      }
      const review = i > eq.length;
      host.innerHTML = `<div class="abk-st" role="dialog" aria-modal="true" aria-label="Customise your kit">
        <header class="abk-st__head"><div><button type="button" data-close>${review ? 'Close' : 'Cancel'}</button><strong>${review ? 'Review your kit' : 'Customise your kit'}</strong><span>${review ? '' : `${i + 1} of ${steps}`}</span></div><div class="abk-st__bar">${bar}</div></header>
        <div class="abk-st__body">${body}</div>
        <footer class="abk-st__foot">${review
          ? `<button type="button" class="abk-m-btn abk-m-btn--full" data-add>Add tank + kit to basket</button><p class="abk-status" data-status role="status" aria-live="polite"></p>`
          : `<p>Kit so far <b>${this.fmt(tot.now)}</b>${tot.was > tot.now ? ` · saving ${this.fmt(tot.was - tot.now)}` : ''}</p><div><button type="button" class="abk-st__back" data-step-go="back">${i === 0 ? 'Close' : 'Back'}</button><button type="button" class="abk-m-btn" data-step-go="next">Next: ${esc(next)}</button></div>`}</footer></div>`;
      host.querySelector('.abk-st__body').scrollTop = 0;
    },

    mobileClick(event) {
      if (!this.classList.contains('is-mobile')) return;
      const go = event.target.closest('[data-step]');
      if (go) { this.step = Number(go.dataset.step); this.renderStepper(); return; }
      const nav = event.target.closest('[data-step-go]');
      if (nav) {
        const {steps} = this.mobileSlots();
        this.step = nav.dataset.stepGo === 'next' ? Math.min(this.step + 1, steps) : this.step - 1;
        if (this.step < 0) this.step = null;
        this.renderStepper();
        return;
      }
      if (event.target.closest('[data-close]')) { this.step = null; this.renderMobile(); return; }
      const pick = event.target.closest('[data-pick]');
      if (pick && !pick.disabled) {
        const slot = this.kit.slots.find(s => s.slot === pick.dataset.slot);
        this.overrides[slot.slot] = pick.dataset.pick;
        this.renderMobile();
      }
    }
  };

  const install = () => {
    const Kit = customElements.get('aquarium-builder-kit');
    Object.assign(Kit.prototype, methods);
    document.querySelectorAll('aquarium-builder-kit').forEach(el => { if (el.kit) el.render(); });
  };
  if (customElements.get('aquarium-builder-kit')) install();
  else customElements.whenDefined('aquarium-builder-kit').then(install);
})();